import { AuthorizationsObject, OAuthProfile } from '@dat/angular-auth';

export interface IIqUserCapabilities {
    [key: string]: boolean;
}

export interface IIqUserModalInfo {
    showAgain: boolean;
    first: boolean;
}

export interface IIqUserModals {
    [key: string]: IIqUserModalInfo;
}

export interface IIqUserUiState {
    [key: string]: unknown;
}

export interface IIqUserResources {
    laneCreditsUsed?: number;
    laneCreditsAvailable?: number;
    laneCreditsLastUpdated?: Date;
}

export interface IIqUser {
    id: string;
    loaded?: boolean;
    loggedIn?: boolean;
    oAuthProfile?: OAuthProfile;
    authorizations?: AuthorizationsObject;
    capabilities?: IIqUserCapabilities;
    modals?: IIqUserModals;
    uiStates?: IIqUserUiState;
    cachedUis?: string[];
    resources?: IIqUserResources;
}

export const IQ_USER_CAPABILITY_KEY_PREFIX: string = `cp_`;

export const emptyIqUser: IIqUser = {
    id: '',
};